<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: calc(100% - 20px);margin: 0 20px;padding-top: 20px">
      <div style="height: 50px;">
        <el-button type="primary" plain icon="el-icon-plus" @click="addOpen()">新增</el-button>
<!--        <el-button type="success" @click="getSearchData">查询</el-button>-->
      </div>
      <div style="height: calc(100% - 60px)">
        <el-table :data="tableData" border highlight-current-row height="100%">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="s_name"
            label="护理类别"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="sub_items"
            label="护理项目"
            min-width="200"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button :disabled="scope.row.s_id !== 99 && scope.row.reserved === '1'" size="mini" :type="scope.row.s_id !== 99 && scope.row.reserved === '1' ? 'info' : 'primary'" plain @click="editOpen(scope.row)">修改</el-button>
              <el-button :disabled="scope.row.reserved === '1'" size="mini" :type="scope.row.reserved === '1' ? 'info' : 'danger'" plain @click="delOpen(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :visible.sync="serviceProjectShow" v-if="serviceProjectShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-service-project :serviceProjectObj="serviceProjectObj" v-model="serviceProjectShow" @updateTable="updateTable"></add-edit-service-project>
    </el-dialog>
  </div>
</template>

<script>
import {queryeservicelist, updateeservice} from '../../api/yanglaoyuan/eservice'
import addEditServiceProject from './components/addEditServiceProject'

export default {
  name: 'serviceProject',
  components: {addEditServiceProject},
  data () {
    return {
      entityId: 0,

      tableData: [],

      addEditTitle: '',
      serviceProjectShow: false,
      serviceProjectObj: {
        openType: 0,
        row: ''
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getSearchData()
  },
  methods: {
    getSearchData () {
      this.getEserviceList()
    },
    updateTable () {
      this.getSearchData()
    },

    addOpen () {
      this.addEditTitle = '新增护理类别'
      this.serviceProjectObj.openType = 1
      this.serviceProjectObj.row = ''
      this.serviceProjectShow = true
    },
    editOpen (row) {
      this.addEditTitle = '修改护理类别'
      this.serviceProjectObj.openType = 2
      this.serviceProjectObj.row = row
      this.serviceProjectShow = true
    },
    delOpen (row) {
      this.$confirm('此操作将删除该护理类别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          oper_type: 2,
          eid: row.eid,
          s_id: row.s_id
        }
        updateeservice(data).then(res => {
          this.$notify({title: '成功', message: '成功删除该护理类别', type: 'success', duration: 2000})
          this.updateTable()
        })
      })
    },

    // 访问接口
    // 获取护理项目
    getEserviceList () {
      this.tableData = []
      let params = {}
      let data = {
        eid: this.entityId
      }
      queryeservicelist(params, data).then(res => {
        this.tableData = res.data.arrdata
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/serviceProject.vue